import React from 'react'
import Image from 'react-bootstrap/Image';
const importAll = (r) => r.keys().map(r);

// Load images from src/assets/images/
const images = importAll(require.context('../Assets/clients', false, /\.(png|jpe?g|svg)$/));

export default function ClientGallery() {
    return (
        <div>
            {images.map((img, index) => (
                <Image
                    key={index}
                    src={img}
                    alt={`Image ${index + 1}`}
                    className="rounded-xl shadow-md"
                />
            ))}
        </div>
    )
}
